// apikey를 환경변수를 활용해 .env를 적용하고 싶지만 제출 방식에 있어서 바로 실행 가능해야 함.
export const API_HOST = 'http://www.omdbapi.com';
export const API_KEY = '92e32667';
